import React, { useEffect, useState, useCallback, useRef } from 'react';

export default function DownloadApp({ setShowDownloadApp }) {
  //背景をタップ時
  const tapBack = () => {
    setShowDownloadApp(false);
  };

  const renderApp = () => {
    return (
      <>
        <div id="loadingBack" onClick={tapBack}></div>
        <div className="profile-main-loader">
          <div id="waitingWrap">
            <div className="waitingText">To use this function, need to download app</div>
            <button className="waitingCancelButton">Download App</button>
          </div>
        </div>
      </>
    );
  };

  return renderApp();
}
